import { Flex, Form, Input, Modal } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  onCancel: () => void
  onOk: () => void
}
export const TreatmentTemplateModal = ({ onCancel, onOk, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      open
      maskClosable={false}
      onCancel={onCancel}
      onOk={onOk}
      centered
      {...props}
    >
      <Flex vertical gap={16}>
        <Form.Item
          name="template_name"
          label={t('counterparts.template_name')}
          rules={requiredRules}
          layout="vertical"
        >
          <Input placeholder={t('counterparts.template_name')} />
        </Form.Item>
        <Form.Item
          name="template_description"
          label={t('counterparts.template_description')}
          rules={requiredRules}
          layout="vertical"
        >
          <Input placeholder={t('counterparts.template_description')} />
        </Form.Item>
      </Flex>
    </Modal>
  )
}
